import { createApp } from 'vue'
import withUUID from 'vue-uuid'
import axios from 'axios'
import 'es6-promise/auto'
import PrimeVue from 'primevue/config'
import Aura from '@primevue/themes/aura'
import es6ObjectAssign from 'es6-object-assign'
import moment from 'moment-timezone'
import ConfirmationService from 'primevue/confirmationservice'
import ToastService from 'primevue/toastservice'
import router from '@/router'
import store from '@/store'
import App from '@/App.vue'
import filters from './filters'
import { registerNotificationServices } from './notifications'
import eventBus from './event-bus'
import clickOutside from './click-outside'
import 'es6-symbol/implement'

// IE Compatibility Packages for Object.assign() and Symbol
es6ObjectAssign.polyfill()

// Global imports
window.moment = moment
window.env = 123

const app = withUUID(
    createApp({
        extends: App,
        beforeCreate() {
            this.$store.dispatch('initializeStore')
        },
    })
        .use(ConfirmationService)
        .use(ToastService)
        .use(router)
        .use(store)
        .use(eventBus)
        .use(PrimeVue, {
            theme: {
                preset: Aura,
                options: {
                    prefix: 'p',
                    darkModeSelector: false,
                    cssLayer: false,
                },
            },
        })
)

axios.defaults.baseURL = '/api-internal'
axios.defaults.headers.common = {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
}
app.config.globalProperties.$http = axios

// Lets Vuex modules and other non-component code reach the same toast and
// confirmation services the mixins use.
registerNotificationServices({
    toast: app.config.globalProperties.$toast,
    confirm: app.config.globalProperties.$confirm,
})
app.config.globalProperties.$filters = filters

app.directive('click-outside', clickOutside)
app.directive('focus', {
    mounted(el) {
        el.focus()
    },
})
app.mount('#app')
